import { features } from '@/mocks/home';
import SectionHeading from './SectionHeading';
import ScrollReveal from './ScrollReveal';

export default function Features() {
  return (
    <section className="bg-white">
      <div className="section-padding">
        <SectionHeading
          index="01"
          eyebrow="核心功能"
          title="为什么选择天天漫画"
          subtitle="从海量资源到智能推荐，每一处细节都为更好的阅读体验而设计。"
        />

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto">
          {features.map((feature, i) => (
            <ScrollReveal key={feature.title} delay={(i % 3) * 80}>
              <div className="group relative h-full rounded-lg border-2 border-gray-900 bg-white p-8 md:p-9 shadow-[4px_4px_0_0_#ff9db8] hover:shadow-[4px_4px_0_0_#1a1a1a] hover:-translate-y-1.5 transition-all duration-300 overflow-hidden">
                {/* 网点角标 */}
                <div className="absolute top-3 right-3 w-14 h-14 halftone-pink pointer-events-none" />
                <div className="flex items-start justify-between mb-6">
                  <div className="w-14 h-14 rounded-lg border-2 border-gray-900 bg-pink-50 flex items-center justify-center group-hover:rotate-6 transition-transform duration-300">
                    <i className={`${feature.icon} text-2xl text-pink-500`} />
                  </div>
                  <span className="font-serif text-sm font-bold text-gray-300">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{feature.desc}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}